/**
 * ScoreTag — hiển thị điểm THEO THANG 10 (CLAUDE.md §13, chốt 2026-07-14).
 * Mọi nơi hiển thị điểm học viên đạt được (KHÁC % cấu hình như trọng số/
 * ngưỡng đạt) phải dùng component này thay vì tự inline `toFixed()`/`%`.
 */
import { Tag, Typography } from "antd";

const { Text } = Typography;

const KEM_MAX = 5; // < 5 = kém
const TOT_MIN = 8; // >= 8 = tốt, [5, 8) = trung bình

export function scoreColor(value: number): "red" | "gold" | "green" {
  if (value < KEM_MAX) return "red";
  if (value < TOT_MIN) return "gold";
  return "green";
}

/** Quy đổi % (0-100, vd `total_pct`/`score_pct` từ BE) sang thang điểm 10. */
export function pctTo10(pct: number): number {
  return pct / 10;
}

export function ScoreTag({
  value,
  precision = 1,
}: {
  /** Điểm THANG 10 (0-10) — dùng `pctTo10()` nếu nguồn là %. `null`/`undefined` = chưa có điểm. */
  value: number | null | undefined;
  precision?: number;
}) {
  if (value == null) return <Text type="secondary">—</Text>;
  return <Tag color={scoreColor(value)}>{value.toFixed(precision)}</Tag>;
}
